import { FC } from 'react'
import TextField from '@mui/material/TextField'

export const Input: FC<IInput> = ({
  defaultValue,
  value,
  type,
  label,
  onChange,
  onBlur,
  disabled = false,
  fullWidth = false,
  variant = 'outlined',
  autoComplete,
  rowsAmount,
  ...props
}) => {
  return (
    <TextField
      type={type}
      fullWidth={fullWidth}
      defaultValue={defaultValue}
      variant={variant}
      value={value}
      label={label}
      color='warning'
      onChange={(e: any) => onChange?.(e.currentTarget.value)}
      onBlur={(e: any) => onBlur?.(e.currentTarget.value)}
      autoComplete={autoComplete}
      disabled={disabled}
      multiline={Boolean(rowsAmount)}
      rows={rowsAmount}
      {...props}
    />
  )
}

interface IInput {
  label?: string
  value?: string
  variant?: 'outlined' | 'filled' | 'standard'
  onChange?: (e: string) => void
  onBlur?: (e: string) => void
  defaultValue?: string
  fullWidth?: boolean
  type?: string
  autoComplete?: string
  disabled?: boolean
  rowsAmount?: number
  [key: string]: any
}
